export const TAG_SELECTION_PREVIEW = "tag_selection_preview";

export const TAG_PIECE_PREVIEW = "tag_piece_preview";

export const TABLE_PUZZLE_TAG_ACTIVATED = "table_puzzle_tag_activated";
